import { appModulesToRequiredUserRoles } from "@jugl-web/domain-resources/common/consts";
import { PageNavParams } from "@web-src/modules/navigation/types";
import { ModulePagesConfig } from "@web-src/modules/navigation/types/ModulePagesConfigs";
import { FormType, SubscriptionPlanModuleId } from "@jugl-web/rest-api";
import { lazy } from "react";

const OrderFormsPage = lazy(() => import("./OrderFormsPage"));
const OrderFormSubmitPage = lazy(() => import("./OrderFormSubmitPage"));
const OrderFormWizardPage = lazy(() => import("./OrderFormWizardPage"));

export type OrdersPagesNavigationParams = {
  orderForms: PageNavParams;
  orderFormCreate: PageNavParams;
  orderFormEdit: PageNavParams<
    {
      formId: string;
    },
    {
      flow: string;
    }
  >;
  orderFormSubmit: PageNavParams<{
    formId: string;
    formType: FormType;
  }>;
};

export const ordersPagesNavigationConfig: ModulePagesConfig<OrdersPagesNavigationParams> =
  {
    orderForms: {
      element: <OrderFormsPage />,
      path: "orders/forms",
      isPrivate: true,
      requiredUserRoles: appModulesToRequiredUserRoles.orderForms,
      requiredModules: [SubscriptionPlanModuleId.orderForm],
    },
    orderFormCreate: {
      element: <OrderFormWizardPage />,
      path: "orders/forms/create",
      isPrivate: true,
      requiredUserRoles: appModulesToRequiredUserRoles.orderForms,
      requiredModules: [SubscriptionPlanModuleId.orderForm],
    },
    orderFormEdit: {
      element: <OrderFormWizardPage />,
      path: "orders/forms/edit/:formId",
      isPrivate: true,
      requiredUserRoles: appModulesToRequiredUserRoles.orderForms,
      requiredModules: [SubscriptionPlanModuleId.orderForm],
    },
    orderFormSubmit: {
      element: <OrderFormSubmitPage />,
      path: "orders/forms/submit/:formType/:formId",
      isPrivate: true,
      requiredUserRoles: appModulesToRequiredUserRoles.orderForms,
      requiredModules: [SubscriptionPlanModuleId.orderForm],
    },
  };
